import { render, staticRenderFns } from "./NsHeaderMarketingMessage.vue?vue&type=template&id=5c6d7bb1&scoped=true&"
import script from "./NsHeaderMarketingMessage.vue?vue&type=script&lang=js&"
export * from "./NsHeaderMarketingMessage.vue?vue&type=script&lang=js&"
import style0 from "./NsHeaderMarketingMessage.vue?vue&type=style&index=0&id=5c6d7bb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6d7bb1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c6d7bb1')) {
      api.createRecord('5c6d7bb1', component.options)
    } else {
      api.reload('5c6d7bb1', component.options)
    }
    module.hot.accept("./NsHeaderMarketingMessage.vue?vue&type=template&id=5c6d7bb1&scoped=true&", function () {
      api.rerender('5c6d7bb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsHeaderMarketingMessage.vue"
export default component.exports